import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { useReducer } from 'react';

var DEFAULT_STATE = {
  isHovered: false,
  showTooltip: false
};
var TOOLTIP_ACTIONS = {
  HOVER_START: 'hoverStart',
  HOVER_END: 'hoverEnd',
  FOCUS_START: 'focusStart',
  FOCUS_END: 'focusEnd',
  CLICK_TOGGLE: 'clickToggle',
  CLICK_CLOSE: 'clickClose',
  CLICK_OUTSIDE: 'clickOutside',
  CLICK_TOOLTIP: 'clickTooltip',
  PRESS_ESCAPE: 'pressEscape',
  TOUCH_END: 'touchEnd'
};
var HOVER_START = TOOLTIP_ACTIONS.HOVER_START,
  HOVER_END = TOOLTIP_ACTIONS.HOVER_END,
  FOCUS_START = TOOLTIP_ACTIONS.FOCUS_START,
  FOCUS_END = TOOLTIP_ACTIONS.FOCUS_END,
  CLICK_TOGGLE = TOOLTIP_ACTIONS.CLICK_TOGGLE,
  CLICK_CLOSE = TOOLTIP_ACTIONS.CLICK_CLOSE,
  CLICK_OUTSIDE = TOOLTIP_ACTIONS.CLICK_OUTSIDE,
  CLICK_TOOLTIP = TOOLTIP_ACTIONS.CLICK_TOOLTIP,
  PRESS_ESCAPE = TOOLTIP_ACTIONS.PRESS_ESCAPE,
  TOUCH_END = TOOLTIP_ACTIONS.TOUCH_END;
function clickReducer(state, _ref) {
  var type = _ref.type;
  switch (type) {
    // using click behaviour, focus and hover don't open tooltip
    // instead they control a separate hovered state
    case FOCUS_START:
    case HOVER_START:
      return _objectSpread(_objectSpread({}, state), {}, {
        isHovered: true
      });
    // the inverse of the above two actions
    case FOCUS_END:
    case HOVER_END:
      return _objectSpread(_objectSpread({}, state), {}, {
        isHovered: false
      });
    // toggle works as you'd expect
    case CLICK_TOGGLE:
    case TOUCH_END:
      return _objectSpread(_objectSpread({}, state), {}, {
        showTooltip: !state.showTooltip
      });
    // clicks and escape work as expected...
    case CLICK_CLOSE:
    case CLICK_OUTSIDE:
    case PRESS_ESCAPE:
      return _objectSpread(_objectSpread({}, state), {}, {
        showTooltip: false
      });
    // ... except clicking the tooltip body, which does nothing (need to click the close button)
    case CLICK_TOOLTIP:
    default:
      return state;
  }
}
function hoverReducer(state, _ref2) {
  var type = _ref2.type;
  switch (type) {
    // focus and hover now open the tooltip, rather than having their own state
    case FOCUS_START:
    case HOVER_START:
      return _objectSpread(_objectSpread({}, state), {}, {
        showTooltip: true
      });
    // using hover behaviour, toggle still toggles
    case CLICK_TOGGLE:
    case TOUCH_END:
      return _objectSpread(_objectSpread({}, state), {}, {
        showTooltip: !state.showTooltip
      });
    // all other interactions will close the tooltip
    case HOVER_END:
    case FOCUS_END:
    case CLICK_TOOLTIP:
    case CLICK_CLOSE:
    case CLICK_OUTSIDE:
    case PRESS_ESCAPE:
      return _objectSpread(_objectSpread({}, state), {}, {
        showTooltip: false
      });
    default:
      return state;
  }
}
function useTooltipState(activateOnHover) {
  var _useReducer = useReducer(activateOnHover ? hoverReducer : clickReducer, DEFAULT_STATE),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    _useReducer2$ = _useReducer2[0],
    isHovered = _useReducer2$.isHovered,
    showTooltip = _useReducer2$.showTooltip,
    dispatch = _useReducer2[1];
  return {
    showTooltip: showTooltip,
    isHovered: isHovered,
    onHoverStart: function onHoverStart() {
      return dispatch({
        type: HOVER_START
      });
    },
    onHoverEnd: function onHoverEnd() {
      return dispatch({
        type: HOVER_END
      });
    },
    onFocusStart: function onFocusStart() {
      return dispatch({
        type: FOCUS_START
      });
    },
    onFocusEnd: function onFocusEnd() {
      return dispatch({
        type: FOCUS_END
      });
    },
    onClickToggle: function onClickToggle() {
      return dispatch({
        type: CLICK_TOGGLE
      });
    },
    onClickClose: function onClickClose() {
      return dispatch({
        type: CLICK_CLOSE
      });
    },
    onClickOutside: function onClickOutside() {
      return dispatch({
        type: CLICK_OUTSIDE
      });
    },
    onClickTooltip: function onClickTooltip() {
      return dispatch({
        type: CLICK_TOOLTIP
      });
    },
    onPressEscape: function onPressEscape() {
      return dispatch({
        type: PRESS_ESCAPE
      });
    },
    onTouchEnd: function onTouchEnd() {
      return dispatch({
        type: TOUCH_END
      });
    }
  };
}

export { useTooltipState as default };
